import React, {useEffect, useState} from 'react';
import 'flowbite';
import PostLoginGetApi from "../Api/PostLoginGetApi";
import {toast} from "react-toastify";
import {TreeSelect} from "primereact/treeselect";
import "primereact/resources/themes/lara-light-blue/theme.css";
import {PrimeReactProvider} from "primereact/api";
import Tailwind from "primereact/passthrough/tailwind";


function MultiLevelDropdown({selectedGlobalCategory, setSelectedGlobalCategory,}) {
    const [globalCategoryList, setGlobalCategoryList] = useState([]);

// Get Global Category Lists
    useEffect(() => {

        PostLoginGetApi("global-category").then((responseJSON) => {
            let response = JSON.stringify(responseJSON);
            response = JSON.parse(response);

            if (response["status"] === 1) {
                let responseData = JSON.stringify(response["data"]);
                responseData = JSON.parse(responseData);

                if (responseData["code"] === 200) {
                    setGlobalCategoryList(responseData["data"]);
                }

                toast.error(response["messages"]?.toString() ?? response["message"]?.toString());
            }

        }).catch((err) => {
            console.log(err);
        });
    }, []);

    return (
        <>
            <PrimeReactProvider value={{unstyled: false, pt: Tailwind}}>
                <div className="!w-full">
                    <TreeSelect value={selectedGlobalCategory}
                                onChange={(e) => setSelectedGlobalCategory(e.value)}
                                options={globalCategoryList}
                                filter
                                className="md:w-20rem !w-full border boder-1 ring-1 rounded"
                                placeholder="Select Global Category">
                    </TreeSelect>
                </div>
                <style jsx="true">{`
                    .p-tree-selectable {
                        z-index: 999999 !important;
                    }

                    .p-treeselect-filter {
                        border-radius: 8px !important;
                    }

                `}</style>
            </PrimeReactProvider>
        </>)
}

export default MultiLevelDropdown;
